import { Dispatch, SetStateAction } from "react";
import { EntryItem, GroupFilterSelected, GroupFilterType } from "../types/GroupFilters.type";
import { BookingFilterMode } from "../../Domain/booking-filter-mode-enum.type";

export const handleFilterCheckValChange = (
  event: any,
  type: GroupFilterType,
  filterItems: GroupFilterSelected[],
  setFilterItems: Dispatch<SetStateAction<GroupFilterSelected[]>>
) => {
  const { id, name, checked } = event.target;
  const numId = Number(id);

  if (checked) setFilterItems(prev => [...prev, { id: numId, name, checked, type }]);
  else {
    // '||' is changed from '&&' condition
    // to remove the one item where both id and name match, and keep the rest
    setFilterItems(filterItems.filter(curr => curr.id !== numId || curr.name !== name));
  }
};

/* istanbul ignore next */
export const handleFilterQtyChange = (
  event: any,
  setFilterItems: Dispatch<SetStateAction<GroupFilterSelected[]>>
) => {
  const { id, name, value } = event.target;
  const numId = Number(id);

  // when input is Quantity
  setFilterItems(prev =>
    prev.map(item =>
      item.id === numId && item.name === name
        ? { ...item, quantity: value === undefined ? item.quantity : Number(value) }
        : item
    )
  );
};

export function initFilterSubStyles(
  type: GroupFilterType,
  showDetailGroupFilter: boolean,
  toggleMoreItems: boolean,
  isMobile: boolean,
  isCapacityReportUsed: boolean
) {
  const titleTypoFontSizeMobile = "1em";
  const filterBodyPaddingLeftMobile = 2;
  const controlLabelItemForEquipCate = type === GroupFilterType.EQUIPMENTCATEGORY ? 10.5 : 12;
  const controlLabelItemResponsiv = isMobile ? 11 : controlLabelItemForEquipCate;

  const filterSubStyles = {
    expandIconTransform: toggleMoreItems ? "rotate(0deg)" : "rotate(180deg)",
    titleTypoFontSize: isMobile ? titleTypoFontSizeMobile : "1.1em",
    filterBodyPaddingLeft: isMobile ? filterBodyPaddingLeftMobile : 4,
    descItemXsMobile: showDetailGroupFilter ? 12 : 0,
    dividerWidth: isMobile ? "90%" : "98%",
    controlLabelMinWidth:
      type === GroupFilterType.EQUIPMENTCATEGORY ? "-webkit-fill-available" : "100%", // "60%" : "100%"
    controlLabelItemXs: isCapacityReportUsed ? 9 : controlLabelItemResponsiv
  };

  return filterSubStyles;
}

export function initFilterSubItemStyles(
  type: GroupFilterType,
  showDetailGroupFilter: boolean,
  isMobile: boolean
) {
  const descItemXsForEquipCate = showDetailGroupFilter ? 8 : 0;
  const entryNameXsForEquipCate = type === GroupFilterType.EQUIPMENTCATEGORY ? 8 : 12;
  const entryNameXsForEquipCateDetail = showDetailGroupFilter ? 4 : 8;

  const filterSubItemStyles = {
    entryNameXs: isMobile ? entryNameXsForEquipCate : entryNameXsForEquipCateDetail,
    quantityFieldWidth: isMobile ? "55px" : "70px",
    quantityFieldXs: isMobile ? 1 : 1.5, // 1 : false,
    descItemXs: type === GroupFilterType.EQUIPMENTCATEGORY ? descItemXsForEquipCate : 8,
    descItemPaddingLeft: type === GroupFilterType.EQUIPMENTCATEGORY ? 1.5 : 0
  };

  return filterSubItemStyles;
}

/** look for already selected filter items and return entry's checked and quantity */
export function genInitialEntries(
  filterItems: GroupFilterSelected[],
  entry: EntryItem,
  type: GroupFilterType,
  filterMode: BookingFilterMode
) {
  const initial = filterItems.find(item => item.type === type && entry.id === item.id);

  let initialDefaultChecked: boolean | undefined = initial?.checked;
  let initialDefaultQuantity: number | undefined = initial?.quantity;

  if (type === GroupFilterType.PLACECATEGORY && filterMode === BookingFilterMode.INITIAL) {
    initialDefaultChecked = undefined;
    initialDefaultQuantity = undefined;
  }

  return { initialDefaultChecked, initialDefaultQuantity };
}
